import { createTheme, Theme } from '@mui/material/styles';

const theme: Theme = createTheme({
  palette: {
    primary: {
      light: '#78869E',
      main: '#43485c',
      dark: '#000000',
      contrastText: '#000',
    },
    secondary: {
      light: '#FFDF68',
      main: '#FFCC11',
      dark: '#DCB520',
      contrastText: '#fff',
    },
    error: {
      light: '#F5D0D1',
      main: '#ED1C24',
      dark: '#ED1C24',
      contrastText: '#fff',
    },
    warning: {
      light: '#FFD4A8',
      main: '#FF8000',
      dark: '#FF8000',
      contrastText: '#fff',
    },
    info: {
      light: '#C2DDF1',
      main: '#1991EB',
      dark: '#1991EB',
      contrastText: '#fff',
    },
    success: {
      light: '#B9DFCC',
      main: '#008A45',
      dark: '#008A45',
      contrastText: '#fff',
    },
  },
  typography: {
    fontFamily: ['Lato', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    h1: {
      fontFamily: 'lato-bold, Helvetica, Arial, sans-serif',
      fontSize: '48px',
      lineHeight: '58px',
      letterSpacing: '0.03em',
      color: '#43485C',
    },
    h2: {
      fontFamily: 'lato-black, Helvetica, Arial, sans-serif',
      fontSize: '24px',
      lineHeight: '34px',
      letterSpacing: '0.7px',
      textTransform: 'uppercase',
      color: '#43485C',
    },
    h3: {
      fontFamily: 'lato-bold, Helvetica, Arial, sans-serif',
      fontSize: '19px',
      lineHeight: '28px',
      letterSpacing: '-0.03px',
      color: '#43485C',
    },
    h4: {
      fontFamily: 'lato-black, Helvetica, Arial, sans-serif',
      fontSize: '16px',
      lineHeight: '20px',
      textTransform: 'uppercase',
      color: '#43485C',
    },
    h5: {
      fontFamily: 'lato-regular, Helvetica, Arial, sans-serif',
      fontSize: '16px',
      lineHeight: '18px',
      textTransform: 'uppercase',
      color: '#43485C',
    },
    h6: {
      fontFamily: 'lato-bold, Helvetica, Arial, sans-serif',
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: '-0.03px',
      color: '#43485C',
    },
    subtitle1: {
      fontFamily: 'lato-regular, Helvetica, Arial, sans-serif',
      fontSize: '16px',
      lineHeight: '18px',
    },
    body1: {
      fontFamily: 'lato-regular, Helvetica, Arial, sans-serif',
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: '-0.03px',
    },
    body2: {
      fontFamily: 'lato-regular, Helvetica, Arial, sans-serif',
      fontSize: '12px',
      lineHeight: '15px',
    },
  },
});

export default theme;
